import styled from 'styled-components';
import type { Props as IllustrationProps } from '@kiwicom/orbit-components/lib/Illustration/types';
import { Illustration, Stack } from '@kiwicom/orbit-components';

import Heading from './Heading';

type TextWrapperProps = {
  withMargin: boolean;
};

const TextWrapper = styled.div<TextWrapperProps>`
  max-width: 370px;
  margin-bottom: ${({ theme, withMargin }) => withMargin && theme.orbit.space600};
`;

type Props = {
  readonly illustrationName: IllustrationProps['name'];
  readonly illustrationSize?: IllustrationProps['size'];
  readonly dataTest?: string;
  readonly children: JSX.Element;
  readonly title: JSX.Element;
  readonly as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  readonly callToAction?: JSX.Element;
  readonly inline?: boolean;
  readonly direction?: 'row' | 'column';
  readonly align?: 'center' | 'start' | 'end';
};

const MissingDataScreen = ({
  children,
  illustrationName,
  illustrationSize = 'medium',
  title,
  callToAction,
  dataTest,
  as,
  direction = 'row',
  align = 'center',
  inline = false,
}: Props): JSX.Element => {
  return (
    <Stack
      tablet={{
        direction,
        align,
      }}
      direction="column"
      align={align}
      flex
      justify="center"
      spacing="1000"
      dataTest={dataTest}
      inline={inline}
    >
      <Illustration name={illustrationName} size={illustrationSize} />
      <div>
        <Heading type="title2" spaceAfter="small" as={as}>
          {title}
        </Heading>
        <TextWrapper withMargin={Boolean(callToAction)}>{children}</TextWrapper>
        {callToAction}
      </div>
    </Stack>
  );
};

export default MissingDataScreen;
